import { styled } from '@mui/material/styles';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Main container
export const ChartContainer = styled(MDBox)(({ height }) => ({
  display: 'flex',
  height: height || '100%',
  flexDirection: 'column',
  justifyContent: 'center',
}));

// Chart wrapper
export const ChartWrapper = styled(MDBox)({
  display: 'flex',
  justifyContent: 'center',
});

// Legend container
export const LegendContainer = styled(MDBox)({
  padding: '0 16px 16px 16px',
});

// Row
export const LegendRow = styled(MDBox)({
  display: 'flex',
  marginBottom: '8px',
  justifyContent: 'space-between',
});

// Left section
export const LegendLeft = styled(MDBox)({
  display: 'flex',
  alignItems: 'center',
});

// Dot
export const LegendDot = styled(MDBox)(({ color }) => ({
  width: 8,
  height: 8,
  marginRight: '8px',
  borderRadius: '50%',
  backgroundColor: color,
}));

// Label
export const LegendText = styled(MDTypography)({
  color: '#7b809a',
  fontSize: '0.75rem', // equivalent to variant="button"
});

// Value
export const LegendValue = styled(MDTypography)({
  fontSize: '0.75rem',
  fontWeight: 'bold',
  color: '#344767',
});
